module.exports = __webpack_public_path__ + "static/media/email.32685dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/email.png
// module id = 89
// module chunks = 0